import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import {
	useCreateGroupMutation,
	useUpdateGroupMutation
} from '@features/project-management-tools/api/projectManagementApi';
import { COLOR_CODE_LIST } from '@features/project-management-tools/constents';

import ModalContainer from '@/components/modals/ModalContainer';
import InputField from '@/components/InputField';
import { toastError, toastSuccess } from '@/components/Toast';
import { closeLoader, openLoader } from '@/store/actions/LoaderAction';
import { useMyProjectDetails } from '@/store/reducers';
import CommonImage from '@/components/CommonImage';

const CreateAndEditGroup = ({ onClose, selectedGroupToEdit, projectId, refetchGroups }) => {
	const { groupList } = useMyProjectDetails();
	const [groupInput, setGroupInput] = useState({ groupName: '', colorCode: COLOR_CODE_LIST[0] });
	const [errors, setErrors] = useState({});
	const dispatch = useDispatch();

	const [createGroup] = useCreateGroupMutation();
	const [editGroup] = useUpdateGroupMutation();

	const validateInput = () => {
		const newErrors = {};
		if (!groupInput?.groupName) {
			newErrors.groupName = 'Group Name is required.';
		}
		if (!selectedGroupToEdit && groupList?.some((group) => group?.name === groupInput?.groupName)) {
			newErrors.groupName = 'Group Name already exists.';
		}
		setErrors(newErrors);
		return Object.keys(newErrors).length === 0;
	};

	useEffect(() => {
		if (selectedGroupToEdit) {
			setGroupInput({
				...groupInput,
				groupName: selectedGroupToEdit?.groupName,
				colorCode: selectedGroupToEdit?.colorCode
			});
		}
	}, [selectedGroupToEdit]);

	const handleSubmit = () => {
		if (!validateInput()) {
			return;
		}

		if (selectedGroupToEdit) {
			dispatch(openLoader());
			editGroup({
				body: {
					sl: selectedGroupToEdit?.sl,
					id: selectedGroupToEdit?.groupId,
					name: groupInput?.groupName,
					colorCode: groupInput?.colorCode
				}
			})
				.unwrap()
				.then(() => {
					toastSuccess('New Group Created');
					refetchGroups();
					onClose();
				})
				.catch((error) => {
					toastError(error?.data?.message);
				})
				.finally(() => {
					dispatch(closeLoader());
				});
		} else {
			dispatch(openLoader());
			createGroup({
				projectId,
				body: { name: groupInput?.groupName, colorCode: groupInput?.colorCode }
			})
				.unwrap()
				.then(() => {
					toastSuccess('New Group Created');
					refetchGroups();
					onClose();
				})
				.catch((error) => {
					toastError(error?.data?.message);
				})
				.finally(() => {
					dispatch(closeLoader());
				});
		}
	};
	return (
		<ModalContainer>
			<div className="wraper container-fluid dashboard-container">
				<div className="popup-wrapper">
					<form className="common-popup products-upload-modal" onSubmit={handleSubmit}>
						<div className="common-popup-header d-flex justify-content-between">
							<div className="popup-tilte">
								<h3 className="semibold-16 mb-0">
									{selectedGroupToEdit ? 'Edit Group' : 'Add New Group'}
								</h3>
							</div>
							<div className="close-btn">
								<CommonImage alt="close" src="/icons/close.svg" onClick={onClose} />
							</div>
						</div>
						<div className="common-popup-body">
							<div className="row">
								<div className="col-md-12 pr-2">
									<div className="form-group">
										<InputField
											labelTitle="Group Name*"
											type="text"
											name="linkTitle"
											value={groupInput?.groupName}
											onChange={(e) =>
												setGroupInput((prev) => ({
													...prev,
													groupName: e.target.value
												}))
											}
											onKeyDown={(e) => {
												if (e.key === 'Enter') {
													e.preventDefault();
													e.stopPropagation();
													handleSubmit();
												}
											}}
											withWrapper={false}
											errors={errors?.groupName}
										/>
									</div>
								</div>
								<div className="col-md-12">
									<div className="select-tag-dropdown shadow-none">
										<div className="create">
											<div className="colors px-0">
												{COLOR_CODE_LIST?.map((item, index) => (
													<span
														key={`tag_color_$${index}`}
														className={`single-color ${groupInput?.colorCode === item ? 'active' : ''}`}
														style={{ background: item }}
														onClick={() => {
															setGroupInput((prev) => ({
																...prev,
																colorCode: item
															}));
														}}
													/>
												))}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="modal-footer">
							<div className="footer-buttons text-right">
								<button className="button outline size32 ml-2" onClick={onClose}>
									Cancel
								</button>
								<button className="button size32 ml-2" type="submit">
									Submit
								</button>
							</div>
						</div>
					</form>
				</div>
			</div>
		</ModalContainer>
	);
};

export default CreateAndEditGroup;
